module.exports = __webpack_public_path__ + "static/media/schedule-offsets.1efa0a57.svg";